import React from 'react';
import { Button } from '../ui/button';
import { Minus, Plus, Bed, Bath } from 'lucide-react';

export default function RoomBathCounters({ rooms, baths, onRoomsChange, onBathsChange }) {
  const roomOptions = ['Studio', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
  const bathOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

  const getRoomIndex = () => {
    return roomOptions.indexOf(rooms);
  };

  const getBathIndex = () => {
    return bathOptions.indexOf(baths);
  };

  const adjustRooms = (direction) => {
    const currentIndex = getRoomIndex();
    let newIndex;
    if (direction === 'up' && currentIndex < roomOptions.length - 1) {
      newIndex = currentIndex + 1;
    } else if (direction === 'down' && currentIndex > 0) {
      newIndex = currentIndex - 1;
    } else {
      return;
    }
    onRoomsChange(roomOptions[newIndex]);
  };

  const adjustBaths = (direction) => {
    const currentIndex = getBathIndex();
    let newIndex;
    if (direction === 'up' && currentIndex < bathOptions.length - 1) {
      newIndex = currentIndex + 1;
    } else if (direction === 'down' && currentIndex > 0) {
      newIndex = currentIndex - 1;
    } else {
      return;
    }
    onBathsChange(bathOptions[newIndex]);
  };

  return (
    <div className="space-y-6">

      <div className="rooms-baths-grid">
        {/* Rooms Counter */}
        <div className="text-center rb-section">
          <div className="feature-badge gold mx-auto">
            <Bed size={32} strokeWidth={2} className="u-ink-800" />
          </div>
          <h3 className="text-2xl font-bold" style={{color: '#1e5a5a'}}>Rooms</h3>

          <div className="size-slider__controls">
            <Button
              variant="outline"
              size="icon"
              onClick={() => adjustRooms('down')}
              disabled={getRoomIndex() === 0}
              className="btn-circle-lg control-gold"
              aria-label="Decrease rooms"
            >
              <Minus size={60} strokeWidth={4} className="u-teal-600" />
            </Button>

            <div className="counter-value gold">
              <span className="counter-value__text u-teal-600">
                {rooms === 'Studio' ? (
                  <span key="studio" className="inline-block jiggle">S</span>
                ) : (
                  <span key={rooms} className="inline-block jiggle">{rooms}</span>
                )}
              </span>
            </div>

            <Button
              variant="outline"
              size="icon"
              onClick={() => adjustRooms('up')}
              disabled={getRoomIndex() === roomOptions.length - 1}
              className="btn-circle-lg control-gold"
              aria-label="Increase rooms"
            >
              <Plus size={60} strokeWidth={4} className="u-teal-600" />
            </Button>
          </div>

          <p className="text-lg u-ink-600 text-center" style={{ fontWeight: 500 }}>
            {rooms === 'Studio' ? 'Studio Apartment' : `${rooms} Room${rooms === '1' ? '' : 's'}`}
          </p>
        </div>

      {/* Bathrooms Counter */}
        <div className="text-center rb-section">
          <div className="feature-badge teal mx-auto">
            <Bath size={32} strokeWidth={2} className="text-white" />
          </div>
          <h3 className="text-2xl font-bold u-ink-800">Bathrooms</h3>

          <div className="size-slider__controls">
            <Button
              variant="outline"
              size="icon"
              onClick={() => adjustBaths('down')}
              disabled={getBathIndex() === 0}
              className="btn-circle-lg control-emerald"
              aria-label="Decrease bathrooms"
            >
              <Minus size={60} strokeWidth={4} className="u-teal-600" />
            </Button>

            <div className="counter-value teal">
              <span className="counter-value__text u-teal-600">
                <span key={baths} className="inline-block jiggle">{baths}</span>
              </span>
            </div>

            <Button
              variant="outline"
              size="icon"
              onClick={() => adjustBaths('up')}
              disabled={getBathIndex() === bathOptions.length - 1}
              className="btn-circle-lg control-emerald"
              aria-label="Increase bathrooms"
            >
              <Plus size={60} strokeWidth={4} className="u-teal-600" />
            </Button>
          </div>

          <p className="text-lg u-ink-600 text-center" style={{ fontWeight: 500 }}>
            {baths} Bathroom{baths === '1' ? '' : 's'}
          </p>
        </div>
      </div>
    </div>
  );
}
